import { apiClient } from "./client";

export type MediaEntityType = "sopralluogo" | "intervento" | "installation" | "schedule" | "attivazione" | "cliente";

export interface MediaAllegato {
  id: string;
  entity_type: string;
  entity_id: string;
  categoria: string | null;
  tipo: "foto" | "video";
  file_url: string;
  nome_file: string | null;
  mime_type: string | null;
  size_bytes: number | null;
  created_at: string;
}

export async function listMedia(entityType: MediaEntityType, entityId: string): Promise<{ media: MediaAllegato[] }> {
  const { data } = await apiClient.get<{ media: MediaAllegato[] }>("/media", {
    params: { entity_type: entityType, entity_id: entityId },
  });
  return data;
}

export async function uploadMedia(
  entityType: MediaEntityType,
  entityId: string,
  file: File,
  categoria?: string
): Promise<{ media: MediaAllegato }> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("entity_type", entityType);
  formData.append("entity_id", entityId);
  if (categoria) formData.append("categoria", categoria);

  const { data } = await apiClient.post<{ media: MediaAllegato }>("/media", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function deleteMedia(id: string): Promise<{ success: true }> {
  const { data } = await apiClient.delete<{ success: true }>(`/media/${id}`);
  return data;
}
